import styled from 'styled-components'

const H3 = styled.h3``

export default H3
